import React from 'react';
import { AccountingIcon } from 'src/components/Quiz/Icons/AccountingIcon';
import { ArtDesignIcon } from 'src/components/Quiz/Icons/ArtDesignIcon';
import { BusinessIcon } from 'src/components/Quiz/Icons/BusinessIcon';
import { CommunicationsIcon } from 'src/components/Quiz/Icons/CommunicationsIcon';
import { EducationIcon } from 'src/components/Quiz/Icons/EducationIcon';
import { EngineeringIcon } from 'src/components/Quiz/Icons/EngineeringIcon';
import { EnvironmentalIcon } from 'src/components/Quiz/Icons/EnvironmentalIcon';
import { GeneralDegreeIcon } from 'src/components/Quiz/Icons/GeneralDegreeIcon';
import { HealthcareIcon } from 'src/components/Quiz/Icons/HealthcareIcon';
import { HospitalityIcon } from 'src/components/Quiz/Icons/HospitalityIcon';
import { LegalStudiesIcon } from 'src/components/Quiz/Icons/LegalStudiesIcon';
import { NotSureIcon } from 'src/components/Quiz/Icons/NotSureIcon';
import { ScienceMathIcon } from 'src/components/Quiz/Icons/ScienceMathIcon';
import { SocialScienceIcon } from 'src/components/Quiz/Icons/SocialScienceIcon';
import { SupplyChainIcon } from 'src/components/Quiz/Icons/SupplyChainIcon';
import { TechnologyIcon } from 'src/components/Quiz/Icons/TechnologyIcon';
import { TradesIcon } from 'src/components/Quiz/Icons/TradesIcon';
import styles from './Interests.module.scss';

export interface InterestCategory {
	name: string;
	icon: React.ReactNode;
	description?: string;
	facet?: string;
}

export const interestCategories: InterestCategory[] = [
	{
		name: 'Accounting',
		icon: <AccountingIcon size={40} />,
		description:
			'Launch a career in accounting by gaining skills in financial accounting, cost accounting, tax auditing, business, and financial analysis.',
		facet: 'Accounting',
	},
	{
		name: 'Art, Design & Entertainment',
		icon: <ArtDesignIcon size={44} />,
		description:
			'Get creative and hands-on in programs in graphic design, film and production design, and interactive media.',
		facet: 'Art, Design & Entertainment',
	},
	{
		name: 'Business',
		icon: <BusinessIcon size={45} />,
		description:
			'Dive into the world of business and find programs in marketing, human resources, administration, management, and leadership.',
		facet: 'Business',
	},
	{
		name: 'Communications',
		icon: <CommunicationsIcon size={48} />,
		description:
			'Develop your communication, critical thinking, and problem solving skills for careers in public relations (PR), corporate communications, coaching, social media, and more.',
		facet: 'Communications',
	},
	{
		name: 'Education & Teaching',
		icon: <EducationIcon size={42} />,
		description:
			'Prepare for a career in education with programs in e-learning, child psychology, education, and curriculum design.',
		facet: 'Education & Teaching',
	},
	{
		name: 'Engineering',
		icon: <EngineeringIcon size={45} />,
		description:
			'Learn how to use science and technology to solve real-world problems. Specializations include mechanical, civil, industrial, and environmental engineering.',
		facet: 'Engineering',
	},
	{
		name: 'Environmental Science & Sustainability',
		icon: <EnvironmentalIcon size={45} />,
		description:
			'Learn how to protect the environment and contribute to a sustainable future through courses in policy, community engagement, natural resource management, and more.',
		facet: 'Environmental Science & Sustainability',
	},
	{
		name: 'General Degree Programs',
		icon: <GeneralDegreeIcon size={50} />,
		description:
			'Learn to think across disciplines by getting a broad and diverse education. Programs topics include: history, philosophy, mathematics, and creative writing.',
		facet: 'General Degree Programs',
	},
	{
		name: 'Healthcare',
		icon: <HealthcareIcon size={40} />,
		description:
			'Gain healthcare knowledge with degrees focused on nursing, psychology, healthcare management and administration, and healthcare technologies.',
		facet: 'Healthcare',
	},
	{
		name: 'Hospitality & Culinary Arts',
		icon: (
			<span className='padding--bottom_4'>
				<HospitalityIcon size={46} />
			</span>
		),
		description:
			'Develop skills to provide outstanding experiences for all kinds of guests in lodging, food service, tourism, and hospitality.',
		facet: 'Hospitality & Culinary Arts',
	},
	{
		name: 'Legal Studies & Public Policy',
		icon: <LegalStudiesIcon size={48} />,
		description:
			'Pursue an education in legal principles, law enforcement, or public policy. Program topics include: criminal justice, law enforcement, paralegal services, and community affairs.',
		facet: 'Legal Studies & Public Policy',
	},
	{
		name: 'Science & Math',
		icon: <ScienceMathIcon size={45} />,
		description:
			'Deep dive into the world of numbers, facts, and the natural world with programs in math, analytics, data science, biology, chemistry, and more.',
		facet: 'Science & Math',
	},
	{
		name: 'Social Sciences & Psychology',
		icon: (
			<span className={styles.puzzleIcon}>
				<SocialScienceIcon size={48} />
			</span>
		),
		description:
			'Explore human behavior and relationships with a real-life application through professional counseling skills, child psychology, and more.',
		facet: 'Social Sciences & Psychology',
	},
	{
		name: 'Supply Chain Management & Logistics',
		icon: <SupplyChainIcon size={46} />,
		description:
			'Learn about the exchange of goods and services with programs focused on supply chain management, logistics, global commerce, and transportation.',
		facet: 'Supply Chain Management & Logistics',
	},
	{
		name: 'Technology',
		icon: <TechnologyIcon size={48} />,
		description:
			'Expand your technology skills with degrees in information systems, information technology (IT), security, software development, and computer science.',
		facet: 'Technology',
	},
	{
		name: 'Trades & Technical Programs',
		icon: <TradesIcon size={41} />,
		description:
			'Build a solid and successful career through a skilled trade. Programs include: carpentry, electrician, plumbing, appliance repair, HVAC, and more.',
		facet: 'Trades & Technical Programs',
	},
	{
		name: "I'm not sure",
		icon: <NotSureIcon size={40} />,
		facet: "I'm not sure",
	},
];
